<template>
    <v-layout>
        <v-flex>
            <v-card style="width: 50%; margin: auto;" class="pa-0">
                <v-card-text>
                <div v-if="type">
                    <PasswordReset v-if="type === 'resetPassword'" :email="email" :type="type" :token="token" @authResponse="checkAuthResponse"/>
                    <VerifyEmail v-else-if="type === 'verifyEmail'"/>
                    <ChangeEmail v-else-if="type === 'recoverEmail'"/>
                </div>
                <div v-else>
                    <p class="red--text">The URL provided does not match with any mode. You may close this window, and if this keeps happening, contact support at <b>customerportal@danielshealth.ca</b></p>
                </div>
                <v-alert
                :value="tokenExpired"
                type="warning">
                    {{ feedback }}
                </v-alert>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import PasswordReset from '@/components/auth/PasswordReset';
import VerifyEmail from '@/components/auth/VerifyEmail';
import ChangeEmail from '@/components/auth/ChangeEmail';

import firebase from "firebase/app";
import "firebase/auth";

export default {
  components: {
    PasswordReset,
    VerifyEmail,
    ChangeEmail
  },
  data() {
    return {
      email: null,
      type: null,
      token: null,
      tokenExpired: false,
      feedback: null,
      timer: 0
    }
  },
  methods: {
    getRequestDetails: function () {
        const queryString = window.location.search;
        console.log(queryString);
        const queryParams = new URLSearchParams(queryString);
        const requestType = queryParams.has("mode") ? queryParams.get("mode") : null;
        const requestToken = queryParams.has("oobCode") ? queryParams.get("oobCode") : null;
        console.log(requestType);
        console.log(requestToken);
        this.type = requestType;
        this.token = requestToken;
    },
    checkToken: function () {
        firebase.auth().checkActionCode(this.token).then(actionCodeInfo => {
            console.log(actionCodeInfo);
            this.email = actionCodeInfo.data.email;
            this.tokenExpired = false;
        }).catch(tokenError => {
            this.checkAuthResponse(tokenError);
            console.log(tokenError);
        });
    },
    checkAuthResponse: function (authResponse) {
        if (authResponse.code === "auth/expired-action-code") {
            // code expired
            this.feedback = "The password reset token has expired, please request a new password reset link.";
        } else if (authResponse.code === "auth/invalid-action-code") {
            // code was already used or is a bad code
            this.feedback = "The password reset token has already been used. If you'd like to change your password again, get another password reset link.";
        } else if (authResponse.code === "auth/user-disabled") {
            // code cannot be used on an account that has been disabled
            this.feedback = "The password reset token cannot be used. The account has been disabled."
        } else if (authResponse.code === "auth/user-not-found") {
            // code cannot be used on a non-existent account
            this.feedback = "The password reset token cannot be used. The account does not exist or the account has been deleted."
        } else {
            // some other error
            this.feedback = authResponse.message;
        }
        this.tokenExpired = true;
        this.token = null;
    }
  }, 
  mounted() {
      this.getRequestDetails();
      this.checkToken();
  }
}
</script>